import type { RoomSnapshot } from "../../hooks/useRoomConnection";

export interface PhasePulse { key: string; phaseKey: string; playerIds: string[] }
export const phaseKey = (snapshot: RoomSnapshot) => `${snapshot.room.roomCode}:${snapshot.room.gameId}:${snapshot.room.phaseId}`;

// Chỉ đọc sự kiện công khai và chuyển trạng thái sống; không suy đoán vai hay phân tích tên trong câu chữ.
export class PhaseEventGate {
  private game = "";
  private phase = -1;
  private alive = new Map<string, boolean>();
  private seen = new Set<string>();
  private connected = false;
  private resumedAfter = -Infinity;
  private resuming = false;

  resumeAfter(serverTime: number) { this.resumedAfter = serverTime; this.resuming = true; }

  observe(snapshot: RoomSnapshot, options: { connected: boolean; visible: boolean; reduced: boolean; keyboard: boolean }) {
    const game = `${snapshot.room.roomCode}:${snapshot.room.gameId}`;
    const initial = this.game !== game;
    if (initial) { this.game = game; this.phase = -1; this.alive.clear(); this.seen.clear(); }
    if (snapshot.room.phaseId < this.phase) return { transition: null, pulse: null };
    const fresh = snapshot.events.filter(event => !this.seen.has(event.id));
    const deaths = snapshot.players.filter(player => !player.alive && this.alive.get(player.uid) === true).map(player => player.uid);
    const allowed = !initial && !this.resuming && this.connected && options.connected && options.visible && !options.reduced && !options.keyboard && !snapshot.room.paused;
    const transition = allowed && this.phase !== snapshot.room.phaseId ? phaseKey(snapshot) : null;
    const event = allowed && deaths.length ? [...fresh].reverse().find(entry =>
      ["morning_result", "vote_elimination", "hunter_shot"].includes(entry.type)
      && entry.createdAtMs >= this.resumedAfter
      && snapshot.serverNowMs - entry.createdAtMs <= 2500
      && snapshot.serverNowMs >= entry.createdAtMs,
    ) : undefined;
    const pulse: PhasePulse | null = event ? { key: `${phaseKey(snapshot)}:${event.id}`, phaseKey: phaseKey(snapshot), playerIds: deaths } : null;
    // Tiêu thụ cả sự kiện bị bỏ hiệu ứng để không phát lại khi bật hiệu ứng hoặc nối mạng.
    snapshot.events.forEach(entry => this.seen.add(entry.id));
    this.alive = new Map(snapshot.players.map(player => [player.uid, player.alive]));
    this.phase = snapshot.room.phaseId;
    this.connected = options.connected;
    this.resuming = false;
    return { transition, pulse };
  }
}
